import { useTranslation } from 'react-i18next';
import { TableScroll } from '@hp/ui';
import { useEnrichmentRuns } from './queries';
import { StatusBadge } from '../../components/badges';
import { Disclosure } from '../../components/ui/disclosure';
import { BrutTable, BrutTheadRow } from '../../components/ui/table';
import { RelativeTime } from '../../components/relative-time';
import { prettyJson, statsSummary } from '../../lib/format';

export function RunHistory({ lastRun }: { lastRun: Date | null | undefined }) {
  const { t } = useTranslation(['enrichment', 'common']);
  const runs = useEnrichmentRuns(true);
  return (
    <Disclosure
      title={t('history.title')}
      caption={
        lastRun && (
          <>
            {t('common:time.lastCompleted')} <RelativeTime value={lastRun} />
          </>
        )
      }
      flush
    >
      <TableScroll label={t('history.tableLabel')}>
        <BrutTable>
          <BrutTheadRow>
            <th>{t('common:table.id')}</th>
            <th>{t('common:table.status')}</th>
            <th>{t('common:table.started')}</th>
            <th>{t('common:table.finished')}</th>
            <th>{t('common:table.stats')}</th>
          </BrutTheadRow>
          <tbody>
            {(runs.data ?? []).map((run) => (
              <tr key={run.id}>
                <td className="bo-cell-muted">{run.id}</td>
                <td>
                  <StatusBadge status={run.status} />
                </td>
                <td>
                  <RelativeTime value={run.startedAt ?? run.createdAt} />
                </td>
                <td>
                  <RelativeTime value={run.finishedAt} />
                </td>
                {run.error ? (
                  <td className="bo-cell-error">
                    <span className="bo-clip" title={run.error}>
                      {run.error}
                    </span>
                  </td>
                ) : (
                  <td className="bo-cell-note">
                    <span className="bo-clip" title={prettyJson(run.stats)}>
                      {statsSummary(run.stats)}
                    </span>
                  </td>
                )}
              </tr>
            ))}
            {runs.data?.length === 0 && (
              <tr>
                <td colSpan={5} className="bo-cell-empty">
                  {t('history.empty')}
                </td>
              </tr>
            )}
          </tbody>
        </BrutTable>
      </TableScroll>
    </Disclosure>
  );
}
